import { FC } from "react";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import BrowseHeaderWeb from "./layouts/BrowseHeader.web";

const BrowseHeaderComponent = withConditionalComponent(BrowseHeaderWeb, () => null);

const BrowseHeader: FC = () => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <BrowseHeaderComponent trigger={isLargeScreen} props={{}} />;
};

export default BrowseHeader;
